export default __webpack_public_path__ + "static/media/matchmaker-recommend.d0d5d397.webp";